import React, { useEffect, useState } from 'react';

import _ from 'lodash';

import { Skeleton, TextField } from '@mui/material';

import { useEditStatus } from 'global/EditStatusContext';
import { useUserSocialNetworks } from 'hooks/useUserSocialNetworks';

interface ISocialNetworkField {
  socialNetworkType: string;
  placeholder: string;
  onChange?: (username: string) => void;
}

const SocialNetworkField: React.FC<ISocialNetworkField> = ({
  socialNetworkType,
  placeholder,
  onChange,
}) => {
  const { upsertSocialNetwork, getUsernameByType, loading } = useUserSocialNetworks();
  const { setEditStatus } = useEditStatus();
  const existingNetwork = getUsernameByType(socialNetworkType);
  const originalValue = existingNetwork?.social_network_username || '';
  const [username, setUsername] = useState(originalValue);
  const [isEditing, setIsEditing] = useState(false);

  const debouncedUpdate = _.debounce((value: string) => {
    if (value.trim() !== originalValue) {
      if (value.trim() === '') {
        if (existingNetwork) {
          upsertSocialNetwork({
            ...existingNetwork,
            social_network_username: '',
          });
        }
      } else {
        upsertSocialNetwork({
          social_network_type: socialNetworkType,
          social_network_username: value,
        });
      }
      setEditStatus(false, '');
      setIsEditing(false);
      onChange?.(value);
    } else {
      setEditStatus(false, '');
      setIsEditing(false);
      onChange?.(value);
    }
  }, 3000);

  useEffect(() => {
    if (username !== originalValue && !isEditing) {
      setEditStatus(true, username);
      setIsEditing(true);
    }
    debouncedUpdate(username);

    return () => {
      debouncedUpdate.cancel();
    };
  }, [username]);

  useEffect(() => {
    setUsername(originalValue);
  }, [existingNetwork]);

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
      }}
    >
      {loading ? (
        <Skeleton animation="wave" sx={{ width: '100%', height: '4rem' }} />
      ) : (
        <TextField
          variant="outlined"
          //label={placeholder}
          value={username}
          onChange={e => {
            setUsername(e.target.value);
          }}
          fullWidth
        />
      )}
    </div>
  );
};

export default SocialNetworkField;
